<template>
	<div id="recruit">
		<van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
			<van-list v-model="isLoading" :finished="isFinished" finished-text="没有更多了">
				<div v-for="item in list" :key="item.id" class="recruitItem">
					<router-link class="item" :to="{ path: '/recruit/detail', query: { id: item.id, experience_name: item.experience, company_name: item.company } }">
						<van-row>
							<van-col class="info">
								<div class="info-name">{{ item.name }}</div>
								<div class="info-threshold">
									<span>{{ item.experience }}</span
									>&nbsp;|&nbsp;<span>{{ item.education }}</span>
								</div>
								<div class="info-company">{{ item.company }}</div>
								<div class="info-benefit">{{ item.welfare }}</div>
							</van-col>
							<van-col class="salary" v-if="item.is_face == 0">{{ item.min_salary }}K - {{ item.max_salary }}K</van-col>
							<van-col class="salary" v-else>薪酬面议</van-col>
						</van-row>
					</router-link>
				</div>
			</van-list>
		</van-pull-refresh>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	data() {
		return {
			list: [],
			pageNo: 1,
			pageSize: 20,
			isRefresh: false,
			isLoading: false,
			isFinished: false,
		}
	},
	watch: {
		communityId() {
			this.onLoad()
		},
	},
	computed: {
		...mapGetters(['token', 'userId', 'communityId']),
	},
	created() {
		this.communityId.length > 0 && this.onLoad()
	},

	methods: {
		onRefresh() {
			this.list = []
			this.pageNo = 1
			this.onLoad()
			this.$toast('刷新成功')
			this.isRefresh = false
		},
		onLoad() {
			if (this.communityId.length == 0) return
			this.vaxios.get(
				this.vaxios.host + '/open/api/v1/recruits',
				{
					pageNo: this.pageNo,
					pageSize: this.pageSize,
					communityId: this.communityId,
				},
				(res) => {
					let data = res.data.list
					data.forEach((item) => {
						this.list.push({
							id: item.id,
							name: item.name,
							experience: item.experience_name,
							education: item.education_name,
							company: item.company_name,
							min_salary: item.min_salary,
							max_salary: item.max_salary,
							welfare: item.welfare,
							is_face: item.is_face,
						})
					})

					// 加载状态结束
					this.pageNo++
					this.isLoading = false

					// 数据全部加载完成
					if (this.list.length >= res.data.total) {
						this.isFinished = true
					}
				},
				function(err) {
					console.log(err)
				}
			)
		},
	},
}
</script>

<style scoped>
#recruit {
	margin-top: 16px;
}
.recruitItem {
	border-bottom: 1px solid #E4E4E4;
}

.item {
	display: block;
	padding: 12px;
}

.item:focus {
	background-color: #eeeeee;
}

.logo {
	width: 3.125rem;
	height: 3.125rem;
}

.info {
	margin-left: 0.6875rem;
}

.info-name {
	color: #272727;
	font-size: 1rem;
	font-weight: bold;
}

.info-threshold,
.info-company {
	margin-top: 0.09375rem;
	font-size: 0.75rem;
	color: #5c5c5c;
}

.info-benefit {
	margin-top: 0.4375rem;
	font-size: 0.625rem;
	color: #fc5e18;
}

.salary {
	float: right;
	font-size: 0.875rem;
	color: #fc5e18;
	font-weight: bold;
}
</style>
